import LiningCodeSearch from "@/components/LiningCodeSearch";

/**
 * Single-input lining row for a specific garment section (pant, vest, overcoat).
 * Reuses `LiningCodeSearch` so it has full access to the 158-code lining catalog
 * with typeahead, while still allowing free-text entry.
 *
 * Props:
 *   value, onChange — controlled value (the section-specific lining color field)
 *   label — display label (e.g., "Pant lining", "Vest lining")
 *   testId — base data-testid prefix
 */
export default function SectionLiningRow({ value, onChange, label, testId }) {
  return (
    <div className="mt-3 pt-3 border-t border-white/5" data-testid={testId}>
      <p className="text-[10px] uppercase tracking-wider text-slate-400 mb-2">
        {label}
      </p>
      <div className="max-w-xs">
        <LiningCodeSearch
          value={value || ""}
          onChange={onChange}
          placeholder="FLLDL031 / book code"
          testId={`${testId}-input`}
        />
      </div>
    </div>
  );
}
